import {getLocalizedText, texts} from '../../../../constants/TextConst';

export const cx_menu_input_anchor = 'cx_menu_input_anchor';

export const getOperatorsSearchObject = () => {
    return [
        {retval: '=', string1: '=', string2: getLocalizedText(texts.equals)},
        {retval: '<', string1: '<', string2: getLocalizedText(texts.less)},
        {retval: '<=', string1: '<=', string2: getLocalizedText(texts.lessOrEqual)},
        {retval: '>', string1: '>', string2: getLocalizedText(texts.greater)},
        {retval: '>=', string1: '>=', string2: getLocalizedText(texts.greaterOrEqual)},
        {retval: '<>', string1: '<>', string2: getLocalizedText(texts.notEquals)}
    ];
};
